import { jsx as _jsx } from "react/jsx-runtime";
import EmburseProfessionalLogoImage from '../../../assets/images/emburse-professional-logo.svg';
export default function EmburseProfessionalLogo({ width }) {
    const defaultHeight = 36;
    const defaultWidth = 416;
    const aspectRatio = defaultWidth / defaultHeight;
    const imageWidth = width || defaultWidth;
    const imageHeight = imageWidth / aspectRatio;
    return (_jsx("img", { src: EmburseProfessionalLogoImage, alt: "Emburse Professional", title: "Travel and expense solutions that solve for what's next", width: imageWidth, height: imageHeight }));
}
